import { User } from "./user";

export class Material {
    id: string;
    name: string;
    dangerousLevel?: number | null;
    modifiedDate?: Date;
    modifiedUser?: User;
    creationDate?: Date;
    creationUser?: User;
    constructor(material?: Material) {
        this.id = material?.id || "";
        this.name = material?.name || "";
        this.dangerousLevel = material?.dangerousLevel;
    }
}
